<template>
  <div>
    <div
      v-show="!videoShow"
      class="video-mask"
      @click="playVideo"
    >
      <img
        :src="coverImg"
        alt=""
        @load="imgFinished()"
      >
      <div
        class="video-play"
      >
        <i class="icon-play" />
      </div>
    </div>
    <div
      v-show="!complete && videoShow"
      id="video-poster"
      class="sa-v-box"
      @click="playVideo"
    >
      <video
        id="sa-box"
        :poster="coverImg"
        :src="url"
        controls="controls"
        autoplay="autoplay"
        preload
        width="100%"
        x-webkit-airplay="allow"
        webkit-playsinline="true"
        playsinline="true"
        x5-playsinline="true"
        x5-video-player-fullscreen="false"
        style="object-fit:fill"
        @ended="playEnd"
      />
    </div>
  </div>
</template>
<style lang="scss">
.video-mask {
    position: relative;
    padding-bottom: 8px;
    & > img {
        display: block;
        width: 100%;
    }
}
.sa-v-box {
  & > video {
    display: block;
    width: 100%;
  }
}
.video-play {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 4;
    text-align: center;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    overflow: hidden;
}

.video-play>i {
    display: block;
    position: relative;
    z-index: 6;
}

.player-larger:before {
    font-size: 62px;
}
</style>

<script>
export default {
  props: {
    url: {
      type: String,
      default: '',
    },
    coverImg: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      videoShow: false,
      complete: false,
      playing: false,
    };
  },
  methods: {
    imgFinished() {
      this.$emit('img-loaded');
    },
    playVideo() {
      const self = this;
      self.videoShow = true;
      self.complete = false;
      const media = document.querySelector('#sa-box');
      self.$nextTick(() => {
        try {
          if (self.playing) {
            media.pause();
            self.playing = false;
          } else {
            media.play();
            self.playing = true;
          }
        } catch (e) {
          console.log(e);
        }
      });
      return media;
    },
    playEnd() {
      this.complete = true;
      this.videoShow = false;
    },
  },
};
</script>
